import {Stack, Text, Title} from '@mantine/core';
import {DataTable} from 'mantine-datatable';
import {
    ALL_ROLES,
    ROLE_ACCESS_ROWS,
    ROLE_LABELS,
    type RoleAccessRow,
} from '../../utils/roles';
import {BooleanStatusIcon} from '../common/TableActionIcons';

const ROLE_ACCESS_COLUMNS = ALL_ROLES.map((role) => ({
    accessor: role,
    title: ROLE_LABELS[role],
    textAlign: 'center' as const,
    render: (record: RoleAccessRow) => (
        <BooleanStatusIcon
            value={record.hasAccess(role)}
            trueLabel={`${ROLE_LABELS[role]}: ${record.label}`}
            falseLabel={`${ROLE_LABELS[role]}: no access to ${record.label}`}
            falseVariant="neutral"
        />
    ),
}));

export function RoleAccessTable() {
    return (
        <Stack gap="xs" mt="lg">
            <Stack gap={2}>
                <Title order={4} fw={600}>Role access</Title>
                <Text size="sm" c="dimmed">
                    Overview of which roles can use each admin area.
                </Text>
            </Stack>
            <DataTable
                withTableBorder
                striped
                highlightOnHover
                records={ROLE_ACCESS_ROWS}
                idAccessor="label"
                columns={[
                    {accessor: 'label', title: 'Access'},
                    ...ROLE_ACCESS_COLUMNS,
                ]}
            />
        </Stack>
    );
}
